import { Flex, Tag, Typography } from '@duxton-web/ui';
import { cpGetVerticals } from 'omega-rtc/actions/ucd';
import React from 'react';

import { localeSorter, verticalFromApi } from './adapters';
import DeeplinkQr from './DeeplinkQr';
import EntityListPage, { useEntityList } from './EntityListPage';

const columns = [
  {
    title: 'Vertical',
    dataIndex: 'name',
    width: '30%',
    sorter: localeSorter('name', 'id'),
    render: (_v, r) => <Typography.Body level={2}>{r.name || r.id}</Typography.Body>,
  },
  {
    title: 'Code',
    dataIndex: 'id',
    width: 160,
    render: (id) => <Tag>{id}</Tag>,
  },
  {
    // The UCM Content Portal value Content Injection falls back to when a
    // Product Offering defines no deep link of its own. Renders "—" until
    // ucd-ucm ships a value for the vertical.
    title: 'Deep link',
    dataIndex: 'deeplink',
    render: (deeplink, r) => (deeplink ? (
      <Flex align="center" justify="space-between" gap={8}>
        <Typography.Body level={2}>{deeplink}</Typography.Body>
        <DeeplinkQr deeplink={deeplink} label={r.name || r.id} />
      </Flex>
    ) : (
      <Typography.Body level={2} type="secondary">—</Typography.Body>
    )),
  },
];

const VerticalsPage = () => {
  const { data, loading } = useEntityList(
    cpGetVerticals, 'ucd.cpVerticals', 'requests.cpGetVerticalsRequest', verticalFromApi,
  );
  const sortedData = React.useMemo(() => [...data].sort(localeSorter('id')), [data]);
  return (
    <EntityListPage
      title="Verticals"
      rowKey="id"
      columns={columns}
      data={sortedData}
      loading={loading}
      emptyText="No verticals onboarded yet."
    />
  );
};

export default VerticalsPage;
